// extracted by mini-css-extract-plugin
module.exports = {"popupControls":"Dialog_popupControls__3RB5S"};